import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider } from './providers/ThemeProvider';
import { QueryProvider } from './providers/QueryProvider';
import { TelegramProvider } from './providers/TelegramProvider';
import { AppRouter } from './router';

import './styles/tailwind.css';

export function App(): React.JSX.Element {
  return (
    <BrowserRouter>
      <TelegramProvider>
        <ThemeProvider>
          <QueryProvider>
            <AppRouter />
          </QueryProvider>
        </ThemeProvider>
      </TelegramProvider>
    </BrowserRouter>
  );
}
